"use client";

import { useGetCompanyQuery } from "@/api/AppApi/services/company";
import { useCurrencyCalc } from "@/hooks/useCurrencyCalc";
import { useLang } from "@/providers/langProvider";
import Script from "next/script";
import { useEffect, useState } from "react";
type TTabbyPromoProps = {
  selector: string;
  currency: string;
  lang: string;
  price: number;
  installmentsCount?: number;
  source: "cart" | "product";
};

type TTabbyPromo = {
  new (options: TTabbyPromoProps | {}): void;
};
declare global {
  interface Window {
    TabbyPromo: TTabbyPromo;
  }
}

type TProps = Pick<TTabbyPromoProps, "source" | "price">;
const TabbyPromo: React.FC<TProps> = ({ price, source }) => {
  const { data } = useGetCompanyQuery();
  const convert = data?.result?.theme?.settings?.enable_currencies_converter;
  const { currency, convertToCurrentCurrency } = useCurrencyCalc({
    enable: data?.result?.theme?.settings?.enable_currencies_converter ?? true,
  });
  const [ready, setReady] = useState(false);
  const lang = useLang();
  useEffect(() => {
    if (ready)
      new window.TabbyPromo({
        selector: "#TabbyPromo",
        currency: currency.code,
        price: convert ? convertToCurrentCurrency(price) : price,
        installmentsCount: 4,
        lang,
        source,
      });
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [ready, lang, price, currency.code]);
  return (
    <>
      {source !== "product" && <div id="tabby"></div>}
      {/* Tabby's hosted promo script offers no dark option — keep it a light card. */}
      <div id="TabbyPromo" className="tabby-promo theme-light-island"></div>
      {currency.code && (
        <Script
          src="https://checkout.tabby.ai/tabby-promo.js"
          onReady={() => {
            setReady(true);
          }}
        />
      )}
    </>
  );
};

export default TabbyPromo;
